import { connect } from 'react-redux';
import PasswordResetView from './index'
import {passwordReset} from '../../actions/Users'

const mapStateToProps = (state, props) => {
    return {
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	passwordReset: (data) => {
	    return dispatch(passwordReset(data))
	}
    }
}

const PasswordResetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PasswordResetView);




export default PasswordResetContainer;



// WEBPACK FOOTER //
// ./src/components/PasswordReset/Container.js